/* eslint-disable react-hooks/rules-of-hooks */
export const userHasRoles = ( roles : string[], userRoles: any  ) => {
    let hasRole: boolean = false;
    roles.forEach(element => {

      if (userRoles.some( ( e: any ) => e.code === element)) {
        hasRole = true;
      }
    });
   return hasRole;
}


export const userHasRole = ( roles : string[], userRoles: any  ) => {
  let hasRole: boolean = true;
  // roles.forEach(element => {

  //   if (userRoles.some( ( e: any ) => e.code === element)) {
  //     hasRole = true;
  //   }
  // });
 return hasRole;
}